import { breadcrumb } from './breadcrumb';

export const db = {
  breadcrumb,

  database: {
    status: {
      fresh: 'Создание',
      processing: 'Импорт',
      error: 'Ошибка',
      ready: 'Готова',
      removed: 'Удалена',
      sorting: 'Сортировка'
    },

    field: {
      recipients: 'Получатели',
      group: 'Группа'
    },

    table: {
      action: {
        move: 'Переместить',
        add_contact: 'Добавить контакт'
      }
    },

    button: {
      create: 'Создать базу данных'
    },

    form: {
      without_group: 'Без группы'
    },

    modal: {
      remove: {
        content: 'Вы уверены, что хотите удалить базу данных {name}?'
      }
    }
  },

  group: {
    field: {
      databases_count: 'Базы данных'
    },

    modal: {
      remove: {
        content: 'Вы уверены, что хотите удалить группу {name}?'
      }
    },

    button: {
      create: 'Создать группу'
    }
  },

  recipient: {
    required_format: 'Убедитесь, что номер указан в международном формате. Например, +7XXXXXXXXXX.',
    birthdate_format: 'ДД.ММ',
    not_allow_select: 'Невозможно выбрать базу данных, нет получателей',

    field: {
      number: 'Телефон',
      email: 'Email',
      first_name: 'Имя',
      last_name: 'Фамилия',
      age: 'Возраст',
      sex: 'Пол',
      country: 'Страна',
      city: 'Город',
      birthdate: 'Дата рождения',
      custom1: 'Поле #1',
      custom2: 'Поле #2',
      custom3: 'Поле #3',
      custom4: 'Поле #4',
      custom5: 'Поле #5'
    },

    tags: {
      number: 'Телефон',
      email: 'Email',
      first_name: 'Имя',
      last_name: 'Фамилия',
      age: 'Возраст',
      country: 'Страна',
      city: 'Город',
      birthdate: 'Дата рождения',
      custom1: 'Поле #1',
      custom2: 'Поле #2',
      custom3: 'Поле #3',
      custom4: 'Поле #4',
      custom5: 'Поле #5'
    },

    button: {
      create: 'Создать контакт',
      import: 'Импорт',
      export: 'Экспорт',
      sort: 'Сортировать'
    },

    modal: {
      remove: {
        content: 'Вы уверены, что хотите удалить получателя с номером {number}?'
      },

      import: {
        title: 'Импортировать базу данных',
        content: 'Импортировать файл (csv).',
        required_format:
          'Убедитесь, что номера в базе данных в международном формате. Например, +7XXXXXXXXXX.',
        imported: 'База данных импортирована',
        import_title: 'Определите импортируемые поля',
        field_title: {
          id: 'ID',
          created_at: 'Дата создания',
          updated_at: 'Дата обновления',
          hlr_date: 'Hlr_date',
          hlr_state: 'Hlr_state',
          db_id: 'ID базы данных',
          number: 'Телефон',
          mcc: 'Mcc',
          mnc: 'Mnc',
          email: 'E-mail',
          name: 'Name',
          first_name: 'Имя',
          last_name: 'Фамилия',
          age: 'Возраст',
          sex: 'Пол',
          male: 'Мужской',
          female: 'Женский',
          Male: 'Мужской',
          Female: 'Женский',
          country: 'Страна',
          city: 'Город',
          birthdate: 'Дата рождения',
          custom1: 'Поле #1',
          custom2: 'Поле #2',
          custom3: 'Поле #3',
          custom4: 'Поле #4',
          custom5: 'Поле #5'
        }
      },

      export: {
        title: 'Экспорт Базы данных',
        content: 'Выбрать поля для экспорта',
        button: {
          download: 'Скачать'
        },
        success:
          'Экспорт базы данных запущен. Вы получите уведомление со ссылкой на скачивание, когда файл будет готов.'
      }
    },
    successful_sort: 'Успешная сортировка'
  },

  import: {
    tooltip: {
      header: 'Хотя бы один столбец должен быть номером телефона'
    },
    create: {
      description:
        'Номер телефона - обязательное поле для отправки. Каждое поле должно иметь уникальное имя. Вы можете присвоить имена полей фактическим данным.',
      count: 'База данных включает в себя контактов: {count}',
      button: {
        upload_data: 'Загрузить данные',
        ignore_header: 'Игнорировать заголовок'
      }
    }
  },

  tooltips: {
    export_your_db: 'Экспортируйте вашу базу данных в файл в формате csv'
  }
};
